import React from "react";
import CTable from "components/common/Table";
import Text from "components/common/Text";
import {  withRouter } from "react-router";
import Stack from "components/common/Stack";
import { Chip, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Box } from "@mui/system";

const ViewDetails = ({ isLoading, data, manudata, onclickopenDailog }) => {
  let history = useHistory();

  const columns = [
    {
      field: "model",
      headerName: "Number of Vehicle Model",
      valueGetter: (v, d) => {
        return <Typography>{d.vehicleModel.name}</Typography>;
      },
    },

    {
      field: "connector",
      headerName: "Name of Connectors",
      valueGetter: (v, d) => {
        return (
          <>
            <Stack
              direction="column"
              spacing={1}
              alignItems={"center"}
              justifyContent={"center"}
            >
              {d?.connector_data?.map((data, i) => {
                return (
                  <>
                    <Box>
                      <Chip
                        key={i}
                        label={`${data.max_khw} - ${data.name} - ${data.time} `}
                        sx={{
                          background: "#FBFBFB",
                          border: "1px solid #E9E9E9",
                          padding: "0 8px",
                          color: "#202020",
                          marginBottom: "25px",
                        }}
                      />
                      <EditOutlinedIcon
                        onClick={() => {
                          onclickopenDailog(data.id, data.max_khw, data.time);
                        }}
                        sx={{
                          cursor: "pointer",
                          color: "#004AAD",
                          width: "20px",
                          marginLeft: "20px",
                        }}
                      />
                    </Box>
                  </>
                );
              })}
            </Stack>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Text
        variant="h5"
        color="#202020"
        sx={{ fontSize: "24px", fontWeight: "bold", marginBottom: "40px" }}
      >
        <ArrowBackIcon
          sx={{ fontSize: "24px", fontWeight: "bold", marginRight: "10px" }}
          onClick={() => history.goBack()}
        />
        {manudata}
      </Text>
      <CTable
        columns={columns}
        data={data?.result}
        isLoading={isLoading}
        pagination={true}
        localPagination={true}
        page={0}
        rowsPerPage={5}
      ></CTable>
    </>
  );
};

export default withRouter(ViewDetails);
